import { toastTypes } from "../../constant";




export const addTost = ({type, message}) => {
    return {
      type: toastTypes.SHOW_TOAST,
      payload: { type, message },
    };
  };
  